import React from 'react';
import { Container, Bg, Handle, Input, Text } from './ToggleSwitch.style';

interface ToggleSwitchProps {
  ariaLabel?: string;
  checked: boolean;
  disabled?: boolean;
  onValueChange: (value: boolean) => void;
  testID?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, disabled, ariaLabel, onValueChange, testID }) => {
  return (
    <Container
      onClick={() => {
        if (!disabled && onValueChange) onValueChange(!checked);
      }}
      aria-label={ariaLabel}
      aria-checked={checked}
      data-testid={testID}
      $disabled={disabled}
    >
      <Bg $checked={checked} $disabled={disabled} />

      <Handle $checked={checked} $disabled={disabled} />

      <Text style={{ color: disabled ? '#353535' : checked ? 'white' : '#777' }}>On&nbsp;&nbsp;Off</Text>

      <Input type="checkbox" role="switch" disabled={disabled} onChange={() => {}} />
    </Container>
  );
};

export default ToggleSwitch;
